module.exports = __webpack_public_path__ + "fonts/entypo.0ea88478.eot";